export enum CheckoutStep {
  Checkout = 'checkout',
  Payment = 'payment',
  Confirmation = 'confirmation',
  Done = 'done',
}

export enum FormElement {
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
}

export enum QueryParam {
  ExpandCart = 'expand',
}
